import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AddVisitModalComponent } from 'src/app/admin/components/modals/add-visit-modal/add-visit-modal.component';
import { EditVisitModalComponent } from 'src/app/admin/components/modals/edit-visit-modal/edit-visit-modal.component';
import { VisitService } from 'src/app/admin/services/visit.service';
import { VisitorService } from 'src/app/admin/services/visitor.service';
import { environment } from 'src/environments/environment';
import * as signalR from "@microsoft/signalr";
import { BlockedStatusComponent } from 'src/app/admin/components/modals/blocked-status/blocked-status.component';
import { SurchargeModalComponent } from 'src/app/admin/components/modals/surcharge-modal/surcharge-modal.component';
import { Visit } from 'src/app/admin/models/visit.model';
import { ViewQrCodeComponent } from '../../components/modals/view-qr-code/view-qr-code.component';

@Component({
  selector: 'app-visits-page',
  templateUrl: './visits.page.html',
  styleUrls: ['./visits.page.scss'],
})

export class VisitsPage {

  titleNames = {
    home: 'Početna',
    signin: 'Prijava',
    search: 'Pretraga'
  };
  visitors = [];
  selectedVisitor: any = {};
  paginationSettings = { totalItems: 0 };
  page: 'home' | 'signin' | 'search' | 'blocked' = 'home';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  currentPage: number = 1;
  playrooms = [];
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  itemsPerPage: number = 10;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  fullNameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  emailQuery: string = '';
  phoneQuery: string = '';
  visitorStatusQuery: string = '';
  visitStatusQuery: string = '';
  dateBirthFromQuery:string=''
  dateBirthToQuery:string=''

   visitorBirthMonthFromQuery:string=""
   visitorBirthMonthToQuery:string=""
  visitorBirthYearFromQuery:string=""
  visitorBirthYearToQuery:string=""

  
  onlyChildren: boolean = false;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  fullNameBlockedVisitorsQuery: string = '';
  visits$ = this.visitService.visit$;
  connection;
  disconnectedOnPurpose = false;
  visitInterval = null;
  apiUrl = environment.apiUrl;
  errMsg = '';
  roomId;
  visitors$ = this.visitorService.visitors$;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  fullNameVisitorQuery: string = '';
  managers = [];
  selectedVisit: Visit | any = {};
  visitorsArray: any
  ChildrenNames: string
  FullName: string
  showFormRoditelj: boolean = true;
  sakrijKolonu: boolean = false;
  marketingMessageQuery: string = '';
  registrationDateFromQuery:string=""
  registrationDateToQuery:string=""
  constructor(private visitorService: VisitorService, private modalController: ModalController, private visitService: VisitService,
    private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const stepParam = urlParams.get('step');
    if (stepParam === 'signin' || stepParam === 'search' || stepParam === 'blocked') {
      this.changePage(stepParam);
    } else {
      this.loadActiveVisits();
    }

    let loggedUser = JSON.parse(localStorage.getItem('loggedUser'));
    this.roomId = loggedUser.roomId;
    this.selectedVisit = null;
    this.getArrayChildrenNames()
  }

  getArrayChildrenNames() {
    this.visitors$.subscribe({
      next: (arr) => {
        var i: number;
        var j: number;
        this.visitorsArray = arr
        var len = this.visitorsArray.length;

        for (i = 0; i < len; i++) {

          this.visitorsArray[i].children
          if (this.visitorsArray[i].children.length == 0) {
            let ChildrenNamesArray = new Array<string>()
            this.FullName = "-";
            ChildrenNamesArray.push(this.FullName)
            this.ChildrenNames = ChildrenNamesArray.join(' ');
          }
          else {
            let ChildrenNamesArray = new Array<string>()
            for (j = 0; j < this.visitorsArray[i].children.length; j++) {

              this.FullName = this.visitorsArray[i].children[j].fullName;

              ChildrenNamesArray.push(this.FullName)

            }
            this.ChildrenNames = ChildrenNamesArray.join(', ');

          }
          this.visitorsArray[i].children.push(this.ChildrenNames)
        }
      },
    });
  }

  naPromeniCheckbox(event: any) {
    this.sakrijKolonu = !event.target.checked;
  }

  getAllBlockedVisitors() {
    this.currentPage = 1
    this.visitorService.getAllBlockedVisitorEdit({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameBlockedVisitorsQuery: this.fullNameBlockedVisitorsQuery
    });
    this.visitorService.paginationSettings$.subscribe(pagSettings => {
      this.paginationSettings = pagSettings;
    });
  }

  ngOnDestroy() {
    if (this.visitInterval) {
      clearInterval(this.visitInterval);
    }

    if (this.connection) {
      this.connection.stop().catch((err) => console.log(err));
    }
  }

  changeQueryParam(step) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        step
      },
    });
  }

  loadActiveVisits() {
    this.loadActiveVisitLogic()
    if (!this.visitInterval) {
      this.visitInterval = setInterval(() => {
        if (this.page === 'home') {
          this.loadActiveVisitLogic()
        }
      }, 30000);
    }
  }

  loadActiveVisitLogic() {
    this.visitService.getAllVisits({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameVisitorQuery, StatusQuery: this.visitStatusQuery, phoneQuery: this.phoneQuery
    });
    this.visitService.paginationSettings$.subscribe(pagSettings => {
      this.paginationSettings = pagSettings;
    });
  }

  loadNonActiveVisitors() {
    this.visitorService.getAllVisitorsSearch({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery,
      emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery, onlyChildren: this.onlyChildren, marketingMessageQuery: this.marketingMessageQuery,
    dateBirthFromQuery:this.dateBirthFromQuery, dateBirthToQuery:this.dateBirthToQuery,
      registrationDateFromQuery:this.registrationDateFromQuery, registrationDateToQuery:this.registrationDateToQuery,
       visitorBirthMonthFromQuery:this.visitorBirthMonthFromQuery,visitorBirthMonthToQuery:this. visitorBirthMonthToQuery,
       visitorBirthYearFromQuery:this.visitorBirthYearFromQuery,visitorBirthYearToQuery:this. visitorBirthYearToQuery
    });
    this.visitorService.paginationSettings$.subscribe(pagSettings => {
      this.paginationSettings = pagSettings;
    });
  }

  changePage(page) {
    if (page === 'signin') {
      this.loadNonActiveVisitors();
    } else if (page === 'blocked') {
      this.getAllBlockedVisitors();
    } else {
      this.loadActiveVisits();
    }

    this.changeQueryParam(page);
    this.page = page;
    this.currentPage = 1;
    this.selectedVisitor = null;
    this.fullNameQuery = '';

  }

  changePagePagination(pageNumber) {
    this.currentPage = pageNumber;
    if (this.page === 'signin') {
      this.visitorService.getAllVisitorsSearch({
        currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
        fullNameQuery: this.fullNameQuery,
        emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery, onlyChildren: this.onlyChildren, marketingMessageQuery: this.marketingMessageQuery,
     dateBirthFromQuery:this.dateBirthFromQuery, dateBirthToQuery:this.dateBirthToQuery, 
      registrationDateFromQuery:this.registrationDateFromQuery, registrationDateToQuery:this.registrationDateToQuery,
       visitorBirthMonthFromQuery:this.visitorBirthMonthFromQuery,visitorBirthMonthToQuery:this. visitorBirthMonthToQuery,
       visitorBirthYearFromQuery:this.visitorBirthYearFromQuery,visitorBirthYearToQuery:this. visitorBirthYearToQuery
      });
    }
    else if (this.page === 'blocked') {
      this.visitorService.getAllBlockedVisitorEdit({
        currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
        fullNameBlockedVisitorsQuery: this.fullNameBlockedVisitorsQuery
      });
    }

    else {
      this.visitService.getAllVisits({
        currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
        fullNameQuery: this.fullNameQuery, StatusQuery: this.visitStatusQuery, phoneQuery: this.phoneQuery
      });
    }
  }

  getTimeInside(visit) {
    const enter: any = new Date(visit.enter);
    const now: any = new Date(new Date().toISOString().slice(0, -1));
    const diffMs = (now - enter); // milliseconds between now & Christmas
    const diffDays = Math.floor(diffMs / 86400000); // days
    const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    const hrs = diffDays >= 1 ? (diffDays * 24) + diffHrs : diffHrs;
    return `${hrs.toString().length === 1 ? '0' : ''}${hrs}:${diffMins.toString().length === 1 ? '0' : ''}${diffMins}`
  }

  async loadSearchResult() {
    this.currentPage = 1
    this.visitorService.getAllVisitorsSearch({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery,
      emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery, onlyChildren: this.onlyChildren, marketingMessageQuery: this.marketingMessageQuery,
    dateBirthFromQuery:this.dateBirthFromQuery, dateBirthToQuery:this.dateBirthToQuery,
    registrationDateFromQuery:this.registrationDateFromQuery, registrationDateToQuery:this.registrationDateToQuery,
     visitorBirthMonthFromQuery:this.visitorBirthMonthFromQuery,visitorBirthMonthToQuery:this. visitorBirthMonthToQuery,
       visitorBirthYearFromQuery:this.visitorBirthYearFromQuery,visitorBirthYearToQuery:this. visitorBirthYearToQuery
    
    
    });
  }

  async loadSearchVisitIdResult() {
    this.currentPage = 1
    this.visitorService.getAllVisitorIdSearch({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery,
      emailQuery: this.emailQuery, phoneQuery: this.phoneQuery,dateBirthFromQuery:this.dateBirthFromQuery, dateBirthToQuery:this.dateBirthToQuery
    });
  }

  async loadSearchResultVisits() {
    this.currentPage = 1
    this.visitService.getAllVisits({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery, StatusQuery: this.visitStatusQuery, phoneQuery: this.phoneQuery
    });


  }

  async loadBlockedVisitors() {

    this.currentPage = 1

    this.visitorService.getAllBlockedVisitorEdit({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameBlockedVisitorsQuery: this.fullNameBlockedVisitorsQuery
    });

  }

  async openAddVisitModal() {
    if (this.selectedVisitor) {
      const modal = await this.modalController.create({
        component: AddVisitModalComponent,
        componentProps: { visitor: this.selectedVisitor },
        cssClass: 'medium-modal-css',
        backdropDismiss: true,
        swipeToClose: false,
      });

      await modal.present();
    }
  }


  async openEditVisitModal(passVisit: boolean) {
    let visitId = null;
    if (passVisit) {
      visitId = this.selectedVisitor.id
    }

    const modal = await this.modalController.create({
      component: EditVisitModalComponent,
      componentProps: { visitId: visitId },
      cssClass: 'medium-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });

    await modal.present();
  }


  ensureSignalRConnected() {
    if (this.connection.state !== signalR.HubConnectionState.Connected) {
      this.connection.start().then(() => {
        this.connection.send('RegisterSmartCardRequest', this.roomId, 'checkout');
      }).catch((err) => {
        console.log(err);
      });
    } else if (this.connection.state === signalR.HubConnectionState.Connected) {
      this.connection.send('RegisterSmartCardRequest', this.roomId, 'checkout');
    }
  }

  getVisitorStatus(value: number) {
    if (value === 0) {
      return 'Registrovan';
    }
    else if (value === 1) {
      return 'Nepouzdan';
    }
    else if (value === 2) {
      return 'Odjavljen';
    }
     else if (value === 3) {
      return 'Blokiran';
    }
    else if (value === 4)
      return 'Neregistrovan';
    return 'Neregistrovan';
  }

  async openBlockedStatusModal() {
    const modal = await this.modalController.create({
      component: BlockedStatusComponent,
      componentProps: { visitor: this.selectedVisitor },
      cssClass: 'small-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

  async openSurchargeModal() {
    let visitId = null;

    const modal = await this.modalController.create({
      component: SurchargeModalComponent,
      // eslint-disable-next-line object-shorthand
      componentProps: {},
      cssClass: 'basic-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
  }

  onchnge(e: any, index: any) {
    var cl = document.getElementsByClassName(index)

    if (e.target.checked === true) {

      for (let i = 0; i < cl.length; i++) {
        cl[i].classList.remove("tabCol")

        if (index == "cl0") {
          this.showFormRoditelj = true

        }
        else {
          for (let i = 0; i < cl.length; i++) {
            cl[i].classList.add("tabCol")
            if (index == "cl0") {
              this.showFormRoditelj = false

            }


          }
        }
      }
    }
  }

  getCardType(value: number, hours: number): string {
    if (value === 0) {
      if (hours) {
        return 'Sat (' + hours + 'h' + ')';
      } else {
        return 'Sat';
      }
    } else if (value === 1) {
      return 'Poludnevna karta';
    } else if (value === 2) {
      return 'Dnevna karta';
    } else {
      if (hours) {
        return 'Sat (' + hours + 'h' + ')';
      } else {
        return '';
      }
    }
  }

  async getCardByCode(code: string) {
    console.log(code);
    const modal = await this.modalController.create({
      component: ViewQrCodeComponent,
      componentProps: { code },
      cssClass: 'small-modal-css',
      backdropDismiss: true,
    });

    await modal.present();
  }

  openInNewTab() {
  window.open('/admin/birthday-booking', '_blank');
}

}
